/**
 * ClanHall API
 * ClanHall API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: admin@clanhall.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AppSettingSDKModel { 
    key: AppSettingSDKModelKeyEnum;
    name: string;
    desc: string;
    value?: string;
    enabled: boolean;
}
export enum AppSettingSDKModelKeyEnum {
    discord = 'discord',
    emailToken = 'email_token',
    loginEmailPassword = 'login_email_password',
    registerEmailPassword = 'register_email_password'
};



